export default __webpack_public_path__ + "assets/table-management.2cea13b4.svg";